import PublicLayout from '../../components/layouts/PublicLayout';
import { Container } from 'reactstrap';
import Image from 'next/image';
import Link from 'next/link';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {BlogsEndpoint} from '../../lib/Endpoints.jsx';
import ReactPaginate from 'react-paginate';
import { Row, Col } from "reactstrap";
import Head from 'next/head';
import { useRouter } from 'next/router';
import { List, ListInlineItem } from 'reactstrap';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import DefaultImage from '../../public/public/preview-image.jpg';
import parse from 'html-react-parser';

function Awards({meta}) {
    const router = useRouter();
	const [data, setData] = useState([]);

    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);

	useEffect(() => {
        getRequestToApi();

   }, []);

	const getRequestToApi = () => {
		setLoading(true);
		axios.get(BlogsEndpoint,{params:{
			page: currentPage,
			limit: 10,
		}}).then((response) => {
            setLoading(false);
            if (response.status === 200) {
			let pagination = response.data.meta.pagination;
                setData(response.data.data);
                setPageCount(pagination.total_pages);
            }
        },
        (error) => {
             setLoading(false);
        });    
	}

	const renderBlogsData = (data) => {
		return data.map((data, index) => {
			const description = data.attributes.description.substring(0, 100);
			const blogDetailUrl = (data.attributes.slug != null) ? data.attributes.slug : '';
			if(index > 2 ) {
				return (
					<>
					<Col xl="3" lg="4" md="6">
						<div className="main-block">
							<div className="blog-img_section">
								<p className={"b_category "+data.attributes.keyword.split(' ').join('_')}>{data.attributes.keyword}</p>
									<Image src={data.attributes.file ? data.attributes.file : DefaultImage} alt="blog" width="100%" height="100%" layout='fill' />
							</div>
							<div className="blog_content_section">
								<h6 className="blog_name">{data.attributes.title}</h6>
								<p className="description-text-sm">{parse(description+'...')}</p>
								<Link href={"/blogs/" + blogDetailUrl} ><a className="primary-btn"><span>Read More</span></a></Link>
							</div>
						</div>
					</Col>
					</>
				)
			}
			return [];
		});
	}

	const renderSingleBlog = (singleBlog) => {
		if(singleBlog.length && singleBlog[0]) {
			const blog = Array.isArray(singleBlog) && singleBlog[0] ? singleBlog[0].attributes : singleBlog;
			const description = blog.description.substring(0, 300);
			const blogDetailUrl = (blog.slug != null) ? blog.slug : '';
			return (
					<>
					<Col lg="6">
						<div className="blog-img_section">
							<p className={"b_category "+blog.keyword.split(' ').join('_')}>{blog.keyword}</p>
							<Image src={blog.file ? blog.file : DefaultImage} alt="blog" width="100%" height="100%" layout='fill' />
						</div>
					</Col>
					<Col lg="6">
						<div className="blog_content_section">
							<h6 className="blog_name">{blog.title}</h6>
							<p className="description-text-sm">{parse(description+'...')}</p>
							<Link href={"/blogs/" + blogDetailUrl}><a className="primary-btn"><span>Read More</span></a></Link>
						</div>
					</Col>
					</>
				);
		}

		// return renderNoBlogsHtml();
	}

	const renderNoBlogsHtml = () => {
		return (
			<div className=""> {process.env.NEXT_PUBLIC_NO_RECORD_FOUND}</div>
		)
	}

	const renderDoubleBlog = (data) => {

		return data.map((data, index) => {
			if(index > 0 && index <= 2 ) {
				const description = data.attributes.description.substring(0, 300);
				const blogDetailUrl = (data.attributes.slug != null) ? data.attributes.slug : '';
				return (
					<>
					<Col md="6">
						<div className="main-block block1">
							<div className="blog-img_section">
								<p className={"b_category "+data.attributes.keyword.split(' ').join('_')}>{data.attributes.keyword}</p>
								<Image src={data.attributes.file ? data.attributes.file : DefaultImage} alt="blog" width="100%" height="100%" layout='fill' />
							</div>
							<div className="blog_content_section">
								<div className="left_col">
									<h6 className="blog_name">{data.attributes.title}</h6>
								</div>
								<div className="right_col">
									<p className="description-text-sm">{parse(description+'...')}</p>
									<Link href={"/blogs/" + blogDetailUrl}><a className="primary-btn"><span>Read More</span></a></Link>
								</div>
							</div>
						</div>
					</Col>
					</>
				);
			}
			return [];
		});
	}

	return (
		<>
		<Head>
	            <meta name="keywords" content={meta ? meta.keywords : ''} />
	            <title>{meta ? meta.title : ''}</title>
	            <meta name="description" content={meta ? meta.description : ''} />
	            <link rel="canonical" href={process.env.NEXT_PUBLIC_APP_URL + router.asPath} />
	        </Head>
			<div className="banner_breadcrumb_section" id="blogs">
				<Container fluid="xl">
					<h1 className="main-heading-lg">Blogs</h1>
				</Container>
			</div>
			<Container fluid="xl">
				<div className="padding-wrap all_blogs_section" style={{'minHeight': '500px'}}>
					<div id="spinner" className="spinner_req_review" style={{"display": loading ? "block" : "none"}}>
						<div className="lds-spinner">
							<div></div><div></div><div></div><div></div><div></div><div></div>
							<div></div><div></div><div></div><div></div><div></div><div></div>
						</div>
					</div>
					<div className="blog-top-content">
					<p className="description-text">Need expert tips on finding the right talent for your projects? We share useful information on our blog. If you are a vendor or agency, you will find the best advice on spotting a great client and running a business that delivers value to your clients. <br/> 
					If you have specific questions, you can get help in our community. <br/>
					Explore the blog for industry tricks and tips for doing business in today&#39;s world.
					
					</p>
					</div>
					{
						!data.length ? 
							<div className="single_blog_section">
								<Row>
									<ListInlineItem>
										<div className="skeleton_box">
											<Row>
												<div  className="col-md-6">
													<div className="skeleton_img" style={{ backgroundImage: `url(${DefaultImage.src})` }}></div>
												</div>
												<div className="col-md-6">
													<div className="skeleton_lines title_lines">
														<SkeletonTheme color="#202020" highlightColor="#EBEBEB">
															<Skeleton />
															<Skeleton />
														</SkeletonTheme>
													</div>
													<div className="skeleton_lines title_desc">
														<SkeletonTheme color="#202020" highlightColor="#EBEBEB">
															<Skeleton />
															<Skeleton />
															<Skeleton />
															<Skeleton />
														</SkeletonTheme>
													</div>
												</div>
											</Row>
										</div>
									</ListInlineItem>
								</Row>
							</div>
						: 
						<>
							<div className="single_blog_section">
								<Row>
									{renderSingleBlog(data)}
								</Row>
							</div>				
							<div className="double-blog_section">
								<Row>
									{renderDoubleBlog(data)}
								</Row>
							</div>
							<div className="normal_blog_section bottom-spacing_margin">
								<Row>
									{renderBlogsData(data)}
								</Row>
							</div>
							<div className="custom-pagination-fr" style={{'display': pageCount > 1 ? '' : 'none'}}>			
								<ReactPaginate
									breakLabel="..."
									nextLabel=">"
									marginPagesDisplayed={1}
									pageRangeDisplayed={1}
									pageCount={pageCount}
									previousLabel="<"
									nextLinkClassName="next"
									previousLinkClassName="prev"
									activePage={currentPage}
									forcePage={currentPage-1}
									onPageChange={(pageNumber) => { setCurrentPage(pageNumber.selected+1, () => {
										this.getRequestToApi();
									}); }}
									renderOnZeroPageCount={1}
								/>
							</div>
						</>
					}

				</div>
			</Container>
		</>
	)
}

// This gets called on every request
export async function getServerSideProps({ req, res}) {
    try {
        const response = await axios.get(process.env.NEXT_PUBLIC_API_URL+'metas?path=/blogs', { headers: {
            "Accept": "application/json" }
        });

        return { props: { meta: response.data.data,  } }

    } catch (err) {
        const meta = false;

        return { props: { meta } };
    }
}

Awards.Layout = PublicLayout;

export default Awards
